import styled from 'styled-components';

export const PlaybackSpeedButtonLabelContainer = styled.span`
    display: inline-flex;
    align-items: baseline;
    line-height: 1;
`;

export const PlaybackSpeedButtonLabelUnit = styled.span`
    display: inline-block;
    font-size: 1.16em;
    line-height: 1;
    transform: translateY(-0.02em);
`;
